import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { prefixLanguage } from '@/utils/urls'


export default /*@__PURE__*/_defineComponent({
  __name: 'ThankYouModal',
  props: {
    close: { type: Function }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();



const vacanciesUrl = computed(() => {
  const base = prefixLanguage('vacancies')
  return base.startsWith('/') ? base : `/${base}`
})

const __returned__ = { vacanciesUrl, computed, get prefixLanguage() { return prefixLanguage } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})